import React, { useState } from 'react';
import { m, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Al finalizar la compra recibirás un enlace de descarga inmediata en tu correo electrónico. Accedes al instante desde cualquier dispositivo, sin esperas ni envíos.'
}, {
  q: '¿Es seguro el pago?',
  a: 'Sí. El proceso de pago está gestionado por Impultienda con cifrado SSL. Tus datos están completamente protegidos.'
}, {
  q: '¿Es un solo pago?',
  a: 'Sí. Un único pago. Sin suscripciones, sin cargos ocultos, sin letra pequeña.'
}, {
  q: '¿Sirve para entrenadores con poca experiencia?',
  a: 'Sí. Las sesiones están explicadas de manera que cualquier persona con conocimientos básicos de baloncesto puede ejecutarlas. Las consignas clave y las señales de éxito hacen que incluso el entrenador con menos experiencia dirija la sesión con confianza total.'
}, {
  q: '¿Puedo comprar solo algunos tomos?',
  a: 'La colección se vende completa porque la progresión pedagógica entre tomos es parte del valor del sistema. Comprar tomos sueltos rompería la coherencia del método.'
}, {
  q: '¿Qué pasa si tengo jugadores de distintos niveles en el mismo equipo?',
  a: 'El manual incluye señales de avance y variantes por nivel en cada sesión para que puedas adaptar el ejercicio sin cambiar toda la estructura de la clase.'
}, {
  q: '¿En qué formato vienen los archivos?',
  a: 'Todo el material se entrega en PDF de alta calidad, optimizado para imprimir en A4 y para leer en pantalla en tablet o móvil.'
}, {
  q: '¿Tiene garantía de devolución?',
  a: 'Sí. Cuentas con una garantía de 7 días: si tienes problemas para acceder al material, falta alguno de los contenidos anunciados o lo recibido no corresponde con la oferta mostrada en esta página, escríbenos a manualeslistos@gmail.com y lo resolveremos.'
}, {
  q: '¿Puedo comprar el manual desde cualquier país?',
  a: 'El Manual del Entrenador de Baloncesto es un producto digital en español. Puedes comprarlo desde los países admitidos por nuestra plataforma y acceder a los archivos sin necesidad de recibir ningún envío físico.'
}, {
  q: '¿Puedo utilizarlo si entreno en cualquier otro país?',
  a: 'Sí. El material está organizado por edades, niveles y objetivos de entrenamiento. Puedes adaptar los ejercicios, las sesiones y las progresiones a las características de tus jugadores y al sistema de competición de tu país.'
}, {
  q: '¿En qué moneda se realiza el pago?',
  a: 'El precio de la página está expresado en euros. El importe y la moneda final de pago se mostrarán durante el proceso de compra, según las opciones disponibles.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-56" data-mp="2qfx8z5q8bjzc">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-57" data-mp="erio3yjyzpij">
        <div className="text-center" data-id="element-58" data-mp="esacopf5gmzb">
          <SectionTag icon="❓" data-id="element-59" data-mp="ep60p5vg0my3">Resolvemos tus dudas</SectionTag>
        </div>

        <div className="mt-8 space-y-3" data-id="element-60" data-mp="9r4i0m1xipn5">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-white/10 bg-bg-secondary" data-id="element-61" data-mp="3w05m8hh80cgm" data-mpi={i}>
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-orange" aria-expanded={isOpen} data-id="element-62" data-mp="xi9v4tghj3tr">
                  <span className="font-heading text-sm font-semibold text-white sm:text-base" data-id="element-63" data-mp="isccet1br6by">{faq.q}</span>
                  <ChevronDownIcon size={18} className={`flex-shrink-0 text-orange transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-64" data-mp="1ga2mykjtiizw" />
                </button>
                <AnimatePresence initial={false} data-id="element-65" data-mp="10z4kysgsaik5">
                  {isOpen && <m.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-66" data-mp="m23sgmqrqjkm">
                      <p className="px-5 pb-4 text-sm leading-relaxed text-muted" data-id="element-67" data-mp="1jpvr7l5h5sub">{faq.a}</p>
                    </m.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}